module.exports = __webpack_public_path__ + "static/media/cuvette_rack_short.21e28016.svg";